// noinspection JSUnresolvedVariable
/**
 * Translated strings.
 */
export const i18n = localization;

/**
 * Languages ("in Finnish", "in English", etc.)
 */
export const inLanguages = [
    {
        locale: 'fi-FI',
        name: i18n.InFinnish,
    },
    {
        locale: 'sv-FI',
        name: i18n.InSwedish,
    },
    {
        locale: 'en-US',
        name: i18n.InEnglish,
    },
];

/**
 * Language names.
 */
export const languages = [
    {
        key: 'fi-FI',
        text: i18n.Finnish,
        value: 'fi-FI',
    },
    {
        key: 'sv-FI',
        text: i18n.Swedish,
        value: 'sv-FI',
    },
    {
        key: 'en-US',
        text: i18n.English,
        value: 'en-US',
    },
];
